import * as CONST from '../const';
import UICommon from './common';
class UserForm {
    owner;
    el;
    constructor(owner) {
        this.owner = owner;
    }
    renderInContainer(cont) {
        const el = cont.querySelector(`.${CONST.CLASS_PREFIX}form`);
        if (el) {
            this.el = el;
            el.innerHTML =
                `<div class="container">

<div class="row client-info">
    <div class="col-sm-6 col-md-3">
      <input class="validate-required" type="text" id="order-name" name="order-name" placeholder="Имя" tabindex="21" />
    </div>
    <div class="col-sm-6 col-md-3">
      <input type="email" autocomplete="email" id="order-email" name="order-email" placeholder="E-mail" class="validate-required" tabindex="22">
    </div>
    <div class="col-sm-6 col-md-3">
      <input type="tel" name="order-phone" id="order-phone" placeholder="Телефон" class="validate-required" tabindex="23">
    </div>
    <div class="col-sm-6 col-md-3">
      <input name="order-add-info" type="hidden" value="" />
      <textarea name="order-add-info-user" placeholder="Комментарий" rows="4" tabindex="24"></textarea>
    </div>
    <div class="col-sm-6 col-md-3">
      <textarea name="order-image-links" placeholder="${CONST.TEXT.link_to_image}" rows="4" tabindex="25"></textarea>
    </div>
    <input name="order-price" type="hidden" value=""/>
    <input name="order-baget-price" type="hidden" value=""/>
    <div class="col-sm-6 col-md-6 text-left">
      <span class="type--fine-print">Заполняя форму, я соглашаюсь с условиями <a href="https://muse.ooo/info/oferta/">Оферты</a> и даю свое согласие на обработку персональных данных в соответствии <a href="https://muse.ooo/info/politika_konfidentsialnosti_sayta/">Политикой конфиденциальности сайта</a></span>
    </div>
    <div class="col-sm-6 col-md-3">
      <button type="submit" class="btn btn--primary type--uppercase" tabindex="26">Заказать</button>
    </div>
</div>

</div>`;
            this.bindCommentEvents(cont);
        }
    }
    render() {
        if (this.owner) {
            const cont = this.owner.getContainerElement();
            if (cont) {
                this.renderInContainer(cont);
            }
        }
    }
    bindCommentEvents(cont) {
        const commentEl = cont.querySelector('textarea[name="order-add-info-user"]');
        if (commentEl) {
            commentEl.addEventListener('keyup', this.owner.updateOrderInfo.bind(this));
        }
    }
    setProjectPrice(val) {
        this.setFieldValue('order-price', UICommon.formatPrice(val));
    }
    setProjectSummary(val) {
        this.setFieldValue('order-add-info', val);
    }
    setBagetPrice(val) {
        this.setFieldValue('order-baget-price', UICommon.formatPrice(val));
    }
    setFieldValue(name, val) {
        if (typeof this.el !== 'undefined') {
            const inp = this.el.querySelector(`[name="${name}"]`);
            if (inp) {
                inp.value = val;
            }
        }
    }
}
export default UserForm;
